import { useMutation } from '@tanstack/react-query';
import { eposUploadSignInPromise } from 'src/utils/api';
import { useNotification } from 'src/hooks/use-notification';

export const useEposUploadSignIn = () => {
  const { mutateAsync, isPending, isError } = useMutation({
    mutationFn: eposUploadSignInPromise,
  });
  const { enqueueErrorNotification } = useNotification();

  const eposSignInAsync = async () => {
    try {
      const res = await mutateAsync();
      if (!res?.token) {
        enqueueErrorNotification('Something went wrong while signing in');
        return null;
      }

      return res.token;
    } catch (e) {
      enqueueErrorNotification((e as Error)?.message || 'Unknown error');
      return null;
    }
  };

  return {
    eposSignInAsync,
    isLoading: isPending,
    isError,
  };
};
